var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 418,
    height: 47,
    viewBox: "0 0 418 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.08313e-05 93.5061L46.7454 93.5061L46.7454 46.7607L-2.49179e-05 46.7608L-2.08313e-05 93.5061Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07 93.5064L186.815 93.5063L186.815 46.761L140.07 46.761L140.07 93.5064Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4907 93.5064L140.236 93.5063L140.236 46.761L93.4907 46.761L93.4907 93.5064Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.815 93.5064L233.561 93.5063L233.561 46.761L186.815 46.761L186.815 93.5064Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4907 58.4058L105.135 46.761L93.4907 46.761L93.4907 58.4058Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4907 70.2166L93.4907 81.8613L128.425 46.7607L116.78 46.7607L93.4907 70.2166Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4907 93.5064L140.236 46.761L140.236 58.4057L105.135 93.5064L93.4907 93.5064Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.815 93.5063L163.526 70.2168L186.815 46.761L186.815 93.5063Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.526 93.5063L140.236 70.2168L163.526 46.761L163.526 93.5063Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.84 53.6663C184.745 62.7613 184.745 77.5073 193.84 86.6023C202.936 95.6973 217.681 95.6973 226.776 86.6023C235.872 77.5073 235.872 62.7613 226.776 53.6663C217.681 44.5712 202.936 44.5712 193.84 53.6663Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7454 93.5061L23.4559 70.2166L46.7454 46.7607L46.7454 93.5061Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5081 0.121561L93.5081 46.8669L140.253 46.8669L140.253 0.121557L93.5081 0.121561Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.138668 -2.08313e-05L0.138672 46.7454L46.8841 46.7454L46.884 -2.49179e-05L0.138668 -2.08313e-05Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.193 0.0156042L140.193 46.761L186.938 46.761L186.938 0.0156001L140.193 0.0156042Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8232 0.0607702L46.8232 46.8062L93.5686 46.8061L93.5686 0.0607661L46.8232 0.0607702Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.878 0.0764219L186.878 46.8218L233.623 46.8218L233.623 0.0764178L186.878 0.0764219Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.17 0.181663L186.815 11.8264L186.815 0.181662L175.17 0.181663Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.526 0.181712L151.881 0.181713L186.815 35.116L186.815 23.4712L163.526 0.181712Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.236 0.181731L186.815 46.7607L175.17 46.7607L140.236 11.8265L140.236 0.181731Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.236 23.4715L163.526 46.761L151.881 46.761L140.236 35.1162L140.236 23.4715Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.456 11.8265C17.0247 11.8265 11.8112 17.04 11.8112 23.4712C11.8112 29.9024 17.0247 35.116 23.456 35.116C29.8872 35.116 35.1007 29.9024 35.1007 23.4712C35.1007 17.04 29.8872 11.8265 23.456 11.8265Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2013 11.8265C63.7701 11.8265 58.5566 17.04 58.5566 23.4712C58.5566 29.9024 63.7701 35.116 70.2013 35.116C76.6325 35.116 81.8461 29.9024 81.8461 23.4712C81.8461 17.04 76.6325 11.8265 70.2013 11.8265Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.827 0.118722L93.5366 23.4092L116.827 46.6997L140.118 23.4092L116.827 0.118722Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.56 46.76L210.271 23.4705L233.56 0.180994L233.56 46.76Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 418,
    height: 47,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome7);
export default __webpack_public_path__ + "static/media/home7.205e36dff2527903fc64a64c8103bf91.svg";
export { ForwardRef as ReactComponent };